import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string } from 'prop-types';
import Text from '../Text';
/**
 * A component for setting headings (h1...h6).
 */

const Heading = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Text, _extends({
    ref: ref,
    as: "h3",
    "data-testid": "main-title"
  }, props), children);
});
Heading.propTypes = {
  children: string.isRequired
};
Heading.displayName = 'Heading';
export default Heading;